<template lang="pug">
    section#sidebar
        //- .logo
        //-     h2 Rundholz
        nav#sb-main-menu(v-if="mainItems && mainItems.length")
            tree-menu(:items="mainItems" :max-depth="4" v-if="! error && loaded" toggle-event="click")
        hr(v-if="footerItems && footerItems.length")
        nav#sb-footer-menu(v-if="footerItems && footerItems.length")
            tree-menu(:items="footerItems" :max-depth="1" v-if="! error && loaded" toggle-event="click")
</template>

<script>

import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

import NestedSet from '@/nested-set-lib'

export default {
    name: 'Sidebar',
    computed: {
        mainItems() {
            const menus = this.menus || []
            const menu = menus.find(menu => menu.key === 'main-menu')
            let items = _.get(menu, 'menuItems') || []
            items = _.cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        footerItems() {
            const menus = this.menus || []
            const menu = menus.find(menu => menu.key === 'footer-menu')
            let items = _.get(menu, 'menuItems') || []
            items = _.cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        ...mapGetters({
            menus: 'menus',
            loaded: 'loaded',
            error: 'error',
            sidebar: 'sidebar',
        })
    },
    methods: {
        toggleSidebar() {
            this.updateSidebarVisibility(! this.sidebar)
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility',
        })
    },
    mounted() {
        this.$emit('mounted')
    }
}
</script>

<style lang="sass" scoped>
    @import "~@/assets/sass/variables";

    section#sidebar
        background-color: #1D1F20
        background-image: linear-gradient(145deg, #1D1F20, #404348)
        display: flex
        flex-direction: column

        .logo
            color: $white
            text-transform: uppercase
            padding: 15px
            text-align: center
            margin-top: 3rem
            h2
                font-size: 2rem
                font-weight: bold

        #sb-main-menu
            margin-top: 1.5rem
            flex-grow: 1

        hr
            background-color: transparentize($white, 0.9)
            height: 1px

        #sb-footer-menu
            margin-bottom: 1.5rem

        nav
            & ::v-deep
                ul.tree-menu
                    li
                        &.visible
                        & > ul
                            &.tree-menu
                                border-left: 3px solid transparentize($white, 0.9)
                                margin-left: 22px
                        a
                            padding: 10px 20px
                            display: block
                            color: #ffffff
                            &:hover
                                background-color: transparentize($white, 0.9)
                        .tree-item
                            display: flex
                            & > a
                                flex-grow: 1
                            & > button
                                width: 40px
                                background: transparent
                                border: none
                                outline: none
                                color: darken($white, 40%)
                                font-size: 1rem
                                & > i
                                    font-family: "Font Awesome 5 Free"
                                    font-weight: 900
                                    text-decoration: none
                                    font-style: normal
                                    &.is-closed:before
                                        content: "\f078"
                                    &.is-open:before
                                        content: "\f077"
                .show-enter-active, .show-leave-active
                    transition: opacity 0.3s ease, transform 0.3s ease, max-height 0.3s ease
                    transform-origin: left center
                    max-height: 500px
                    overflow: hidden
                .show-enter, .show-leave-to
                    opacity: 0
                    max-height: 0
                    transform: translateX(-15px)
</style>
